// @flow

import { sha1 } from 'js-sha1'

import { stripQuery } from './stripQuery'

export const getSwarmId = (url: ?string) => {
  if (!url || typeof url !== 'string') {
    return undefined
  }

  return sha1(stripQuery(url))
}
